<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" :disabled="$hasExtraModule('equipment') != 'active'" />

        <action-button
          type="delete"
          @click="del(equipmentmanufacturer.id)"
          v-if="equipmentmanufacturer.id && $can('equipment-access') && modal != true"
          :disabled="$hasExtraModule('equipment') != 'active'"
        />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="equipmentmanufacturer.name"
                  v-model="equipmentmanufacturer.name"
                  v-validate="'max:50'"
                  :label="$t('equipmentmanufacturers.name')"
                  :error-messages="errors.collect('equipmentmanufacturer.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="equipmentmanufacturer.status"
                  v-model="equipmentmanufacturer.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_task_status()"
                  :label="$t('tasks.status')"
                  :error-messages="errors.collect('equipmentmanufacturer.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EquipmentManufacturerForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      equipmentmanufacturer: {},
      dictionary: {
        attributes: {
          "equipmentmanufacturer.name": this.$t("equipmentmanufacturers.name"),
          "equipmentmanufacturer.status": this.$t("equipmentmanufacturers.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$hasExtraModule("equipment") == "active") {
      this.$validator.validateAll().then(() => {
        this.$leaveFormConfirmation(next, this.equipmentmanufacturer, this.predata, this.save, this.isFormValid)
      })
    } else {
      next()
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.page_title = this.$t("equipmentmanufacturers.new_title")
      this.equipmentmanufacturer = {
        status: this.$getDefaultDropdown(this.$dd_task_status())
      }

      this.predata = JSON.parse(JSON.stringify(this.equipmentmanufacturer))
    } else {
      axios
        .get(this.API_URL + "equipment-manufacturer/" + this.id)
        .then((res) => {
          this.equipmentmanufacturer = res.data.data
          this.predata = JSON.parse(JSON.stringify(this.equipmentmanufacturer))

          this.page_title = this.$t("equipmentmanufacturers.edit_title", {
            name: this.equipmentmanufacturer.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.equipmentmanufacturer.id) {
              // Create
              axios
                .post(this.API_URL + "equipment-manufacturer", {
                  name: this.equipmentmanufacturer.name,
                  status: this.equipmentmanufacturer.status,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.equipmentmanufacturer = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.equipmentmanufacturer))

                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "equipmentmanufacturers",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.page_title = this.$t("equipmentmanufacturers.edit_title", {
                          name: vm.equipmentmanufacturer.name
                        })
                        vm.$router
                          .replace(this.BACKEND_URL + `/equipment-manufacturers/edit/${vm.equipmentmanufacturer.id}`)
                          .catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "equipment-manufacturer", {
                  id: this.equipmentmanufacturer.id,
                  name: this.equipmentmanufacturer.name,
                  status: this.equipmentmanufacturer.status
                })
                .then((res) => {
                  vm.equipmentmanufacturer = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.equipmentmanufacturer))

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "equipmentmanufacturers",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "equipment-manufacturer/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/equipment-manufacturers")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
